import React from 'react';
import './Experience.css';
import { FaBriefcase } from 'react-icons/fa';

function Experience() {
  const experiences = [
    {
      title: 'Solutions Architect',
      company: 'TechAssist',
      period: 'December 2025 — Present',
      year: 'Present',
      description: 'I design scalable, modern and secure systems that translate business needs into practical, efficient technical solutions.',
      logo: '/img/techassist.png'
    },
    {
        title: 'Founder & Director',
        company: 'ForcePoint Software',
        period: 'January 2023 — Present',
        year: 'Present',
        description: 'I manage and run a software development company that develops tailored software for SME, Not for Profit and Educational sectors.',
        logo: '/img/forcepoint.png'
    },
    {
      title: 'Specialist Technician',
      company: 'Department of Education',
      period: 'January 2022 — Present',
      year: 'Present',
      description: 'I provide services to schools within the Department of Education in Systems and Network Administration, Windows and Mac Desktop Support, Intune, Mosyle, Active Directory, Sharepoint, Azure AD and Office365 Administration, Project Planning and Management, Purchase and Requisition Planning, Disaster Recovery and Backup Solutions, and Mobile Device Management Solutions.',
      logo: '/img/doevic.jpg'
    },
    {
      title: 'Systems Engineer',
      company: 'JB Hi-Fi Education Solutions',
      period: 'January 2022 — December 2025',
      year: '2025',
      description: 'I provided support to JB Hi-Fi Education Solution\'s clientele mainly consisting of schools and other education providers in areas such as Systems and Network Administration, Project Management and other areas as required as part of the Technical Support for Schools (TSSP) program.',
      logo: '/img/jbhifi.png'
    },
    {
      title: 'Systems Administrator / Software Developer',
      company: 'URL Networks Pty Ltd',
      period: 'March 2018 — December 2021',
      year: '2018',
      description: 'Managed a wide range of systems, networks and software including Linux System Administration (Debian, CentOS, Alpine Linux), Network Administration (Mikrotik, Cisco), IP Telephony Systems, Mail Servers, DNS Servers, Database Systems (MariaDB, Redis, Galera, Postgres), Amazon Cloud Infrastructure, and developed integrations with Dynamics, Cliniko, Tableau and other vendors.',
      logo: '/img/url.png'
    },
    {
      title: 'Systems Administrator',
      company: 'Beonic Technologies',
      period: 'April 2015 — March 2018',
      year: '2015',
      description: 'Managed IT infrastructure including VMware ESXi, vCenter, vMotion, Windows and Linux Server Administration, Network Administration (Cisco and Meraki), Active Directory, Group Policies, Exchange, Sharepoint, Azure AD, Office365, and Citrix XenApp/XenDesktop/Director. Also managed systems associated with people counting products and other product suites written in Java/C++.',
      logo: '/img/beonic.jpg'
    },
    {
      title: 'Director',
      company: 'Bay Islands Computer Services',
      period: 'June 2007 — September 2014',
      year: '2007',
      description: 'Managed day-to-day operations of a computer services business on Russell Island in Queensland. Handled repairs, upgrades, builds of computer systems, troubleshooting of customer issues, hardware/software ordering and configuration, invoicing, calls, payments and other core business functions, management of business website including shopping cart system, and tutoring and computer classes.',
      logo: '/img/bics.png'
    }
  ];

  return (
    <div className="experience">
      <div className="container">
        <h2><FaBriefcase className="section-icon" /> Work Experience</h2>
        <div className="timeline">
          {experiences.map((exp, index) => (
            <div key={index} className="timeline-item">
              <div className="timeline-year">{exp.year}</div>
              <div className="timeline-content">
                <div className="experience-header">
                  <div className="company-logo">
                    <img src={exp.logo} alt={`${exp.company} logo`} />
                  </div>
                  <div className="experience-info">
                    <h3>{exp.title}</h3>
                    <h4>{exp.company}</h4>
                    <p className="period">{exp.period}</p>
                  </div>
                </div>
                <p className="description">{exp.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Experience;
